/* No DS :( */ import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../IconWrap';
const ThemeSwitchDark = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({
        disableDefaultColors: true
    }, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 30 30"
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("circle", {
        cx: "15",
        cy: "15",
        r: "11",
        fill: "#292F34"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M15 11c.081 0 .18.005.297.016a.095.095 0 01.028.182 2.667 2.667 0 103.401 3.647c.035-.071.121-.1.192-.065a.143.143 0 01.08.122A2.372 2.372 0 0119 15a4 4 0 11-4-4z"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "14.818",
        cy: "22.389",
        r: "1",
        fill: "#FFF",
        transform: "scale(-1 1) rotate(-45 0 58.163)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "7.818",
        cy: "15.389",
        r: "1",
        fill: "#FFF",
        transform: "scale(-1 1) rotate(-45 0 34.263)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "20.111",
        cy: "10.975",
        r: "1",
        fill: "#FFF",
        transform: "rotate(-135 20.11 10.975)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        d: "M11.51 20.49c.01.009-.003.04-.033.087l-.08.11-.117.137a3.836 3.836 0 01-.069.074l-2.78 2.926-.29-.224 2.961-2.811.145-.131a2.655 2.655 0 01.066-.054l.11-.081c.046-.03.078-.043.087-.033zm14.474-4.888a11.048 11.048 0 01-.093.95l-4.703 4.95c-.19.2-.503.204-.698.008s-.192-.507.009-.698l5.485-5.21zM15.72 4.023c.155.01.309.023.461.04l-6.934 7.38c-.156.165-.44.141-.636-.054s-.22-.48-.053-.636l7.162-6.73z"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "15",
        cy: "15",
        r: "14",
        stroke: "transparent",
        strokeWidth: "2"
    }))));
};
ThemeSwitchDark.displayName = 'ThemeSwitchDark';
export default ThemeSwitchDark;
